/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

// swatches

      (function () {
        function updateColorLabel() {
          document.querySelectorAll('.radio__fieldset--swatches').forEach(function (fieldset) {
            var nameEl = fieldset.querySelector('.radio__legend__option-name');
            var valueEl = fieldset.querySelector('.radio__legend__value');
            if (!nameEl || !valueEl) return;

            var optionName = (nameEl.textContent || '').trim().toLowerCase();
            var selectedValue = (valueEl.textContent || '').trim();

            if (optionName === 'farve' && selectedValue) {
              nameEl.textContent = 'Valgt farve: ' + selectedValue;
            }
          });
        }

        function init() {
          updateColorLabel();
          setTimeout(updateColorLabel, 50);
        }

        document.addEventListener('DOMContentLoaded', init);

        // swatches ændres typisk via klik
        document.addEventListener('click', function (e) {
          if (e.target.closest('.radio__fieldset--swatches') || e.target.closest('.radio__buttons')) {
            setTimeout(updateColorLabel, 0);
          }
        });

        // hvis temaet re-renderer sektioner
        document.addEventListener('shopify:section:load', init);

        console.log('✅ Color label script loaded');
      })();
      